import Pikaday from '../pikaday-mod';

class FormDateField {
  constructor(fieldElement) {
    this.fieldElement = fieldElement;
    this.datePicker = null;
    this.init();
  }

  getOptions() {
    /**
     * OPTIONAL PARAMETERS
     *
     * data-start - int (year), 0 = today
     * data-end - int (year), 0 = today
     * ||
     * data-range - int (range)
     *
     * data-maxdate - new Date()
     * data-mindate - new Date()
     */

    const options = {};

    if (this.fieldElement.getAttribute('data-range')) {
      this.fieldElement.yearRange = this.fieldElement.getAttribute(
        'data-range',
      );
    } else if (
      this.fieldElement.getAttribute('data-start') &&
      this.fieldElement.getAttribute('data-end')
    ) {
      options.yearRange = [
        this.fieldElement.getAttribute('data-start'),
        this.fieldElement.getAttribute('data-end'),
      ];
    }

    if (this.fieldElement.getAttribute('data-mindate')) {
      options.minDate = new Date(
        this.fieldElement.getAttribute('data-mindate'),
      );
    }

    if (this.fieldElement.getAttribute('data-maxdate')) {
      options.maxDate = new Date(
        this.fieldElement.getAttribute('data-maxdate'),
      );
    }

    return options;
  }

  init() {
    this.datePicker = new Pikaday(
      Object.assign(
        {
          field: this.fieldElement,
          format: 'DD.MM.YYYY.',
        },
        this.getOptions(),
      ),
    );
  }

  uninit() {
    this.datePicker.destroy();
  }
}

export default FormDateField;



// WEBPACK FOOTER //
// ./src/js/forms/FormDateField.js